import { Popover as PopoverComponent } from '@mantine/core'

import styles from './popover.module.css'

export const Popover = PopoverComponent.extend({
  classNames: styles,
})
